













import Vue from "vue";
import { mapState, mapActions } from "vuex";
import store from "../store/index";
import { getQueryVariable } from "@/common/common";

export default Vue.extend({
	name: "ReportFooter",
	computed: mapState({
		truthUrl: (state: any) => store.getters.getTruthUrl,
		checkUrl: (state: any) => store.getters.getCheckUrl,
	}),
	created() {},
	data() {
		return {};
	},
	methods: {},
	mounted() {
		if (this.truthUrl === "") {
			let trueLink: string = "";
			let language = getQueryVariable("lang");
			if (RegExp(/test|rd|local/).test(window.location.host)) {
				trueLink =
					language == "tw"
						? "https://truth.rd.wanfangdata.com.cn/int?culture=zh-hant"
						: language == "en"
						? "https://truth.rd.wanfangdata.com.cn/int?culture=en-us"
						: "https://truth.rd.wanfangdata.com.cn/";
			} else {
				trueLink =
					language == "tw"
						? "https://truth.wanfangdata.com.cn/int?culture=zh-hant"
						: language == "en"
						? "https://truth.wanfangdata.com.cn/int?culture=en-us"
						: "https://truth.wanfangdata.com.cn/";
			}
			this.$store.dispatch("setCheckUrl", trueLink);
		}
	},
});
